export const defaultState = {
  loginState: 'LOGGED_OUT',
  loginNumber: null,
  loginCountryCode: null,
  appError: {
    hasError: false,
    errorTitle: 'Something went wrong',
    errorDesc: 'Check your internet connection and try again',
  },
  config: {
    showQChat: false,
    showOPD: false,
    showSubscription: false,
    showMeds: false,
    showLabs: false,
    showFeed: false,
    showFitCoins: false,
    showOffline: false,
    showSymCheck: false,
    insured: false,
    transFitCoins: false,
    insurePortal: 'https://getvisitapp.com/buy-subscription.html',
    cancellationFee: 100,
    showManageDependent: false,
    showHraHeader: true,
    showUpdatedHra: false,
    showWaterTracking: false,
    showHra: false,
  },
  currentActiveTab: 'home',
  showNavigator: false,
  dontShowNavigator: false,
  fitnessActiveTab: 'fitness-library',
  appFileViewer: {
    title: null,
    isOpen: false,
    contentUrl: null,
    type: 'pdf',
  },
};

export default function app(state = defaultState, action) {
  switch (action.type) {
    case 'OTP_SENT':
      return Object.assign({}, state, {
        loginState: action.type,
        loginNumber: action.payload.phoneNumber,
        loginCountryCode: action.payload.countryCode,
      });
    case 'UPDATE_LOGIN_STATE':
      return Object.assign({}, state, {
        loginState: action.payload.state,
      });
    case 'SHOW_ERROR': {
      return Object.assign({}, state, {
        appError: {
          hasError: true,
          errorTitle: action.payload.errorTitle,
          errorDesc: action.payload.errorDesc,
        },
      });
    }
    case 'HIDE_ERROR': {
      return Object.assign({}, state, {
        appError: {
          hasError: false,
          errorTitle: 'Something went wrong',
          errorDesc: 'Check your internet connection and try again',
        },
      });
    }
    case 'SET_APP_CONFIG': {
      const updatedConfig = Object.assign(
        {},
        state.config,
        action.payload.config
      );
      console.log(updatedConfig, action.payload.config);
      return Object.assign({}, state, {
        config: {
          ...updatedConfig,
          showUpdatedHra: action.payload.config.showUpdatedHra || false,
        },
      });
    }
    case 'SET_CURRENT_ACTIVE_TAB': {
      return Object.assign({}, state, {
        currentActiveTab: action.payload,
      });
    }
    case 'SET_SHOW_NAVIGATOR': {
      return Object.assign({}, state, {
        showNavigator: action.payload,
      });
    }
    case 'DONT_SHOW_NAVIGATOR': {
      return Object.assign({}, state, {
        dontShowNavigator: action.payload,
      });
    }
    case 'SET_FITNESS_ACTIVE_TAB': {
      return Object.assign({}, state, {
        fitnessActiveTab: action.payload,
      });
    }
    case 'OPEN_FILE_VIEWER': {
      return Object.assign({}, state, {
        appFileViewer: {
          title: action.payload.title,
          isOpen: true,
          contentUrl: action.payload.contentUrl,
          type: action.payload.type,
        },
      });
    }
    case 'CLOSE_FILE_VIEWER': {
      return Object.assign({}, state, {
        appFileViewer: defaultState.appFileViewer,
      });
    }

    case 'OPEN_I_FRAME': {
      return Object.assign({}, state, {
        iFrame: {
          isOpen: true,
          contentUrl: action.payload,
        },
      });
    }
    case 'CLOSE_I_FRAME': {
      return Object.assign({}, state, {
        iFrame: {
          isOpen: false,
          contentUrl: null,
        },
      });
    }
    default:
      return state;
  }
}
